/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-02 11:21:57
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-04 13:29:04
 */
//定时任务
import http from "../httpConfig";

const table = "ess_scheduler_job";
//验证cron语句是否正确
export const verifyCron = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/checkCronExpressionIsValid/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 查询所有定时任务
export const getTimedTaskList = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/get-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//获取定时任务详情
export const deatailTimedTask = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/get-details/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//新增定时任务接口
export const addTimedTask = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/add/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//修改定时任务内容
export const updateTimedTask = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/update/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//删除定时任务状态
export const deleteTimedTask = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/delete/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//修改定时任务状态
export const updateTimedTaskStatus = (params = {}) => {
  params["~table~"] = table;
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/change-status/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//查询日志接口
export const getLogList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job-log/get-list/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//执行定时任务接口
export const executeTimedTask = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/monitor/job/run/v1", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
